// src/echarts-theme-voltalis-dark.ts
// Palette inspirée de ta maquette VoltaProd
const echartDarkTheme = {
  // Fond global du canvas
  backgroundColor: "#171b27",

  // Palette par défaut des séries
  color: [
    "#22c55e", // vert principal (gisements / courbes importantes)
    "#38bdf8", // bleu clair
    "#a855f7", // violet
    "#facc15", // jaune
    "#f97316", // orange
    "#4b5563", // gris pour séries secondaires
  ],

  textStyle: {
    color: "#E5E7EB", // gris très clair
    fontFamily: '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },

  title: {
    textStyle: {
      color: "#F9FAFB",
      fontWeight: 500,
    },
    subtextStyle: {
      color: "#9CA3AF",
    },
  },

  legend: {
    textStyle: {
      color: "#9CA3AF",
    },
    itemWidth: 14,
    itemHeight: 8,
  },

  grid: {
    top: 32,
    left: 40,
    right: 16,
    bottom: 40,
  },

  tooltip: {
    backgroundColor: "#0d121e",
    borderColor: "#222639",
    borderWidth: 1,
    textStyle: {
      color: "#F9FAFB",
      fontSize: 12,
    },
    axisPointer: {
      lineStyle: {
        color: "#4B5563",
        type: "dashed",
      },
      crossStyle: {
        color: "#4B5563",
      },
      shadowStyle: {
        color: "rgba(15,23,42,0.7)",
      },
    },
  },

  xAxis: {
    axisLine: {
      lineStyle: {
        color: "#1F2937", // gris foncé
      },
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      color: "#6B7280", // gris moyen
      fontSize: 11,
    },
    splitLine: {
      show: false,
    },
  },

  yAxis: {
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      color: "#6B7280",
      fontSize: 11,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: "#111827", // lignes très discrètes
      },
    },
  },

  // Style par défaut des line charts
  line: {
    smooth: true,
    symbol: "none",
    lineStyle: {
      width: 2,
    },
    areaStyle: {
      opacity: 0.12,
    },
  },

  // Bar charts
  bar: {
    barMaxWidth: 18,
    itemStyle: {
      borderRadius: [4, 4, 0, 0],
    },
  },

  dataZoom: {
    handleStyle: {
      color: "#22c55e",
    },
    textStyle: {
      color: "#9CA3AF",
    },
    borderColor: "#111827",
    fillerColor: "rgba(34,197,94,0.16)",
    dataBackground: {
      lineStyle: { color: "#4B5563" },
      areaStyle: { color: "rgba(31,41,55,0.8)" },
    },
  },

  toolbox: {
    iconStyle: {
      borderColor: "#9CA3AF",
    },
  },

  visualMap: {
    textStyle: {
      color: "#E5E7EB",
    },
  },
};

export default echartDarkTheme;
